<template>
    <div class="video">
        <div class="video__top">
            <div class="container">
                <div class="columns">
                    <div class="column">
                        <div class="video__player">
                            <Player
                                v-if="videoId"
                                :isModalUnlock="isModalUnlock"
                                :isOutOfHours="isOutOfHours"
                                :isTimeIsUpRemind="isTimeIsUpRemind"
                                :isTimeIsUp="isTimeIsUp"
                                :videoId="videoId"
                                :title="video.title"
                                :cover="getCover(video.image)"
                            >
                            </Player>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="video__items">
            <div class="container">
                <div class="column">
                    <div class="colum">
                        <h3 class="video__title">
                            <IconSpeaker
                                class="video__speaker"
                                @click="speechSynthesis(videoTitle)"
                            ></IconSpeaker>
                            {{ videoTitle }}
                        </h3>
                    </div>
                </div>

                <div class="columns is-multiline is-mobile">
                    <div
                        class="column is-3-desktop is-6-tablet is-12-mobile video__element"
                        :class="{ active: video._id === item._id }"
                        :style="{ 'border-color': color }"
                        v-for="item in videoList.items"
                        :key="item._id"
                    >
                        <router-link
                            :to="{
                                name: 'Video',
                                params: {
                                    type: item.type.toUpperCase(),
                                    id: item._id,
                                    slug: getSlug(item.url),
                                    from: video.title,
                                },
                            }"
                            class="video__item"
                        >
                            <div class="video__item-cover">
                                <Image
                                    :image="item.image"
                                    :width="324"
                                    :height="182"
                                ></Image>
                                <Labels
                                    v-if="item.label"
                                    :labels="item.label"
                                    :id="item._id"
                                ></Labels>
                            </div>

                            <h5 class="video__item-title">{{ item.title }}</h5>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <Pagination
            v-if="videoList.total_count > itemsPerPage"
            :type="pageType"
            :name="name"
            :id="videoId"
            :itemsPage="itemsPage"
            :itemsPerPage="itemsPerPage"
            :itemsTotalCount="videoList.total_count"
        >
        </Pagination>

        <ModalTimeLimit
            v-if="isModalTimeLimit && activeSubProfile && activeSubProfile._id"
            :isTimeIsUp="isTimeIsUp"
            :isOutOfHours="isOutOfHours"
            :isTimeIsUpRemind="isTimeIsUpRemind"
            :activeSubProfile="activeSubProfile"
            @closeModalHandle="closeModalHandle"
            @stopRecordTime="stopRecordTime"
        >
        </ModalTimeLimit>

        <transition name="fade" appear>
            <ModalUnlock
                v-if="isModalUnlock"
                :itemId="websiteId"
                :path="path"
                @closeModalUnlock="closeModalUnlock"
            >
            </ModalUnlock>
        </transition>
    </div>
</template>

<script>
import axios from "axios";
import Image from "../elements/Image.vue";
import Player from "../elements/Player.vue";
import Pagination from "../elements/Pagination.vue";
import IconSpeaker from "../elements/icons/IconSpeaker.vue";
import Labels from "../elements/Labels.vue";
import ModalTimeLimit from "../modals/ModalTimeLimit.vue";
import ModalUnlock from "../modals/ModalUnlock.vue";
import globalDataLayer from "../../mixins/globalDataLayer";
import { parseImageUrl } from "../../mixins/useParseImage";
import { recordTime } from "../../mixins/recordTime";
import { registerVisit } from "../../mixins/registerVisit";
import { checkIsOutOfHours } from "../../mixins/checkIsOutOfHours";

export default {
    name: "VideoDetail",
    components: {
        Image,
        Player,
        IconSpeaker,
        Pagination,
        ModalTimeLimit,
        Labels,
        ModalUnlock,
    },
    mixins: [
        parseImageUrl,
        recordTime,
        registerVisit,
        checkIsOutOfHours,
        globalDataLayer,
    ],
    props: {
        video: {
            type: Object,
            require: true,
        },
        websiteId: {
            type: Number,
        },
        videoId: {
            type: Number,
        },
        videoTitle: {
            type: String,
        },
        pageType: {
            type: String,
        },
        categoryId: {
            type: Number,
        },
    },
    data() {
        return {
            VIDEO_LIST:
                "/api/krainaabc/video/list?device=www&sort=position,1&id=",
            videoList: [],
            itemsPerPage: 12,
            recordTimeIntervalId: null,
            checkHoursIntervalId: null,
            isModalTimeLimit: false,
            isModalUnlock: false,
        };
    },
    watch: {
        "$route.path": {
            handler: function () {
                this.getVideoList();
            },
            deep: true,
            immediate: true,
        },
        isModalTimeLimit(value) {
            if (value) {
                this.$store.dispatch("changeModalBackdrop", true);
                this.$store.dispatch("changeModalTimeLimitState", true);
            } else {
                this.$store.dispatch("changeModalBackdrop", false);
                this.$store.dispatch("changeModalTimeLimitState", false);
            }
        },
        activeSubProfile(value) {
            if (
                value &&
                value._id &&
                value.game_restriction !== 0 &&
                this.categoryId
            ) {
                if (!this.isCategorySleep) {
                    this.$store.dispatch("setIsOutOfHours", false);
                    this.$store.dispatch("setIsTimeIsUpRemind", false);
                    this.$store.dispatch("setIsTimeIsUp", false);

                    if (
                        this.isTimeIsUp ||
                        (value.remaining_time === 0 && !value.play_from)
                    ) {
                        if (!value.play_from && !value.play_to) {
                            this.isModalTimeLimit = true;
                            clearInterval(this.recordTimeIntervalId);
                            clearInterval(this.checkHoursIntervalId);
                            this.recordTimeIntervalId = null;
                            this.checkHoursIntervalId = null;
                        } else if (this.isOutOfHours) {
                            this.isModalTimeLimit = true;
                            clearInterval(this.recordTimeIntervalId);
                            clearInterval(this.checkHoursIntervalId);
                            this.recordTimeIntervalId = null;
                            this.checkHoursIntervalId = null;
                        }
                    } else if (this.isOutOfHours) {
                        this.isModalTimeLimit = true;
                        clearInterval(this.recordTimeIntervalId);
                        clearInterval(this.checkHoursIntervalId);
                        this.recordTimeIntervalId = null;
                        this.checkHoursIntervalId = null;
                    } else {
                        checkIsOutOfHours();
                        this.recordTimeIntervalId = recordTime(this.categoryId);
                        this.checkHoursIntervalId = setInterval(
                            checkIsOutOfHours,
                            60000
                        );
                    }
                }

                if (this.videoId) {
                    setTimeout(() => {
                        registerVisit(this.videoId, this.activeSubProfile._id);
                    }, 15000);
                }
            } else {
                if (this.recordTimeIntervalId) {
                    clearInterval(this.recordTimeIntervalId);
                    this.recordTimeIntervalId = null;
                }
                if (this.checkHoursIntervalId) {
                    clearInterval(this.checkHoursIntervalId);
                    this.checkHoursIntervalId = null;
                }
            }
        },
        isTimeIsUp(value) {
            if (
                this.activeSubProfile &&
                this.activeSubProfile._id &&
                !this.isCategorySleep
            ) {
                if (
                    value &&
                    !this.activeSubProfile.play_from &&
                    !this.activeSubProfile.play_to
                ) {
                    this.isModalTimeLimit = true;

                    clearInterval(this.recordTimeIntervalId);
                    this.recordTimeIntervalId = null;

                    clearInterval(this.checkHoursIntervalId);
                    this.checkHoursIntervalId = null;
                } else {
                    this.recordTimeIntervalId = recordTime(this.categoryId);
                }
            }
        },
        isTimeIsUpRemind(value) {
            if (
                this.activeSubProfile &&
                this.activeSubProfile._id &&
                !this.isCategorySleep
            ) {
                if (
                    value &&
                    !this.activeSubProfile.play_from &&
                    !this.activeSubProfile.play_to
                ) {
                    this.isModalTimeLimit = true;
                }
            }
        },
        isOutOfHours(value) {
            if (
                this.activeSubProfile &&
                this.activeSubProfile._id &&
                !this.isCategorySleep
            ) {
                if (value) {
                    this.isModalTimeLimit = true;

                    clearInterval(this.checkHoursIntervalId);
                    this.checkHoursIntervalId = null;

                    clearInterval(this.recordTimeIntervalId);
                    this.recordTimeIntervalId = null;
                } else {
                    setTimeout(() => {
                        this.checkHoursIntervalId = setInterval(
                            checkIsOutOfHours,
                            60000
                        );
                    }, 1000);

                    this.recordTimeIntervalId = recordTime(this.categoryId);
                }
            }
        },
        isAgePrevent(newValue) {
            // console.log(`isAgePrevent ${newValue}`);
            if (newValue) {
                this.isModalUnlock = true;
                this.$store.dispatch("changeModalBackdrop", true);
            } else {
                this.isModalUnlock = false;
                this.$store.dispatch("changeModalBackdrop", false);
            }
        },
        getIsModalUnlock(newValue) {
            // console.log(`getIsModalUnlock videoDetail ${newValue}`);
            this.isModalUnlock = newValue;
        },
    },
    computed: {
        color() {
            if (
                this.video &&
                this.video.breadcrumbs &&
                this.video.breadcrumbs[0] &&
                this.video.breadcrumbs[0].color
            ) {
                return this.video.breadcrumbs[0].color;
            }
            return null;
        },
        itemsPage() {
            if (this.$route.query.page) {
                return parseInt(this.$route.query.page);
            }
            if (
                this.$route.params.itemsPage &&
                this.$route.params.itemsPage !== "1"
            ) {
                return parseInt(this.$route.params.itemsPage);
            }
            return 1;
        },
        name() {
            if (this.$route && this.$route.name) {
                return this.$route.name;
            }
            return null;
        },
        activeSubProfile() {
            return this.$store.getters.getActiveSubProfile;
        },
        breadcrumbs() {
            if (
                this.video &&
                this.video.breadcrumbs &&
                this.video.breadcrumbs[0]
            ) {
                return this.video.breadcrumbs[0];
            }
            return null;
        },
        episodeNumber() {
            return this.video.episode_number;
        },
        isTimeIsUp() {
            return this.$store.getters.isTimeIsUp;
        },
        isTimeIsUpRemind() {
            return this.$store.getters.isTimeIsUpRemind;
        },
        isOutOfHours() {
            return this.$store.getters.isOutOfHours;
        },
        isModalErrorOpen() {
            return this.$store.getters.getModalErrorOpen;
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        },
        isCategorySleep() {
            if (
                this.video &&
                this.video.breadcrumbs &&
                this.video.breadcrumbs[0] &&
                this.video.breadcrumbs[0].type &&
                this.video.breadcrumbs[0].type === "CATEGORY_SLEEP"
            ) {
                return true;
            }
            return false;
        },
        isLogged() {
            return this.$store.getters.isLoggedIn;
        },
        path() {
            return this.$route.fullPath;
        },
        getIsModalUnlock() {
            return this.$store.getters.getModalUnlock;
        },
    },
    methods: {
        getVideoList() {
            if (this.websiteId) {
                let endpoint = `${this.VIDEO_LIST}${this.websiteId}`;

                if (this.itemsPage) {
                    endpoint =
                        endpoint +
                        `&limit=${this.itemsPerPage}&page=${this.itemsPage}`;
                }

                axios.get(endpoint).then((response) => {
                    if (response.status === 200) {
                        if (response.data && response.data.data) {
                            this.videoList = response.data.data;
                        }
                    }
                });
            }
        },
        getSlug(url) {
            if (url) {
                return url.substring(url.lastIndexOf("/") + 1);
            }
        },
        getCover(img) {
            if (img && img.url) {
                return parseImageUrl(img.url, 1370, 770);
            }
            return null;
        },
        closeModalHandle() {
            this.$store.dispatch("changeModalTimeLimitState", false);
            this.isModalTimeLimit = false;
        },
        stopRecordTime() {
            clearInterval(this.recordTimeIntervalId);
            this.recordTimeIntervalId = null;
        },
        scrollTop() {
            setTimeout(function () {
                const videoTop = document.querySelector(".video__top");

                const startPos = window.pageYOffset;

                if (videoTop) {
                    const diff = videoTop.getBoundingClientRect().top;

                    window.scrollTo({
                        top: startPos + diff - 80,
                        behavior: "smooth",
                    });
                }
            }, 500);
        },
        closeModalUnlock(isReject) {
            this.isModalUnlock = false;
            this.$store.dispatch("changeModalBackdrop", false);
            if (isReject) {
                this.$router.push({
                    path: this.breadcrumbs.url.substring(
                        this.breadcrumbs.url.lastIndexOf("/")
                    ),
                });
            }
        },
        checkIsFavorite(id) {
            if (
                this.activeSubProfile &&
                this.activeSubProfile.favorites &&
                this.activeSubProfile.favorites.length &&
                this.activeSubProfile.favorites.findIndex((el) => el === id) !==
                    -1
            ) {
                return true;
            }
            return false;
        },
        isAgePrevent() {
            if (
                this.isLogged &&
                this.activeSubProfile &&
                this.activeSubProfile.age < 7 &&
                this.video.target_age_three_six === false &&
                this.video.target_age_seven_ten === true &&
                !this.checkIsFavorite(this.websiteId)
            ) {
                this.isModalUnlock = true;
                this.$store.dispatch("changeModalBackdrop", true);
            }

            return false;
        },
    },
    mounted() {
        this.scrollTop();

        this.videoDetails(
            this.videoId,
            this.breadcrumbs.title,
            this.videoTitle,
            "sub_category",
            this.episodeNumber
        );

        if (this.isCategorySleep) {
            if (
                this.activeSubProfile &&
                this.activeSubProfile._id &&
                this.videoId &&
                this.categoryId
            ) {
                setTimeout(() => {
                    registerVisit(this.videoId, this.activeSubProfile._id);
                }, 15000);
            }
        } else {
            if (
                this.activeSubProfile &&
                this.activeSubProfile._id &&
                this.videoId &&
                this.categoryId
            ) {
                // sprawdzenie czy pozostały czas jest równy 0 i nie przedłużano czasu
                if (
                    this.activeSubProfile.remaining_time === 0 &&
                    !this.activeSubProfile.play_from
                ) {
                    this.$store.dispatch("setIsTimeIsUp", true);
                    this.isModalTimeLimit = true;
                } else {
                    checkIsOutOfHours();

                    setTimeout(() => {
                        registerVisit(this.videoId, this.activeSubProfile._id);
                    }, 15000);

                    this.recordTimeIntervalId = recordTime(this.categoryId);

                    if (!this.isOutOfHours) {
                        this.checkHoursIntervalId = setInterval(
                            checkIsOutOfHours,
                            60000
                        );
                    }
                }
            }
        }

        if (this.isModalErrorOpen) {
            this.$store.dispatch("changeModalErrorOpenState");
            this.$store.dispatch("changeModalBackdrop", false);
        }

        setTimeout(() => {
            window.gemius_event(
                "_view_",
                this.gemiusIdentifier,
                `CATEGORY=${this.breadcrumbs.title}`
            );
        }, 500);

        this.$nextTick(() => {
            this.isAgePrevent();
        });

        // window.addEventListener('offline', () => {
        //     console.log('offline');
        //     this.$store.dispatch("changeModalErrorLoadingState", true);
        //     this.$store.dispatch("changeModalBackdrop", true);
        // });
        // window.addEventListener('online', () => {
        //     console.log('online');
        //     this.$store.dispatch("changeModalErrorLoadingState", false);
        //     this.$store.dispatch("changeModalBackdrop", false);
        // });
    },
    unmounted() {
        this.$store.dispatch("setIsOutOfHours", false);
        this.$store.dispatch("setIsTimeIsUpRemind", false);
        this.$store.dispatch("setIsTimeIsUp", false);
        this.$store.dispatch("changeModalBackdrop", false);
        this.$store.dispatch("changeModalTimeLimitState", false);
        clearInterval(this.recordTimeIntervalId);
        clearInterval(this.checkHoursIntervalId);
        this.recordTimeIntervalId = null;
        this.checkHoursIntervalId = null;
    },
};
</script>
